import type { TierKey } from '@/lib/pricing'
import { useLanguage } from '@/i18n/LanguageContext'

/**
 * Tier stays in the amber/fire family (not cyan) — master prompt §3.2
 * reserves cyan for nav/links/selected-controls/technical highlights, while
 * amber is explicitly for "price totals, savings, ... selected commercial
 * CTAs." A pricing tier is a commercial concept, not a technical one.
 */
const TIER_STYLES: Record<TierKey, string> = {
  basic: 'border-white/20 bg-white/5 text-foreground-muted',
  pro: 'border-accent-amber/50 bg-accent-amber/10 text-accent-amber-light',
  premium: 'border-accent-fire/60 bg-accent-fire/10 text-accent-fire shadow-[0_0_15px_rgba(255,122,69,0.25)]',
}

export function TierBadge({ tier }: { tier: TierKey }) {
  const { t } = useLanguage()
  const labelKey = tier === 'basic' ? 'tier-basic' : tier === 'pro' ? 'tier-pro' : 'tier-premium'
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-pill border px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-widest transition-all duration-normal ${TIER_STYLES[tier]}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {t(labelKey)}
    </span>
  )
}
